'use client';
import React from 'react';
import styled from '@benzinga/themetron';
import { Carousel } from '@benzinga/ui';
import { Card, SectionTitle } from '@benzinga/core-ui';
import { AltOffering } from '@benzinga/alts-manager';
import { ListingPreview } from '../components/ListingPreview';
import Hooks from '@benzinga/hooks';
import { Options } from '@splidejs/react-splide';
import { SplideStyle } from '@benzinga/ui';
import { AltsForm } from '@benzinga/forms-ui';
import { OfferingCardVariant } from '../types';

export interface OfferingsCarouselProps {
  borderedTitle?: boolean;
  items: AltOffering[];
  options?: Options;
  showEmailCapture?: boolean;
  showPagination?: boolean;
  showProductTake?: boolean;
  title?: string;
  variant?: OfferingCardVariant;
}

export const OfferingsCarousel: React.FC<OfferingsCarouselProps> = ({
  borderedTitle,
  items,
  options = {},
  showEmailCapture = false,
  showProductTake = false,
  title,
  variant = 'default',
}) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const { width } = Hooks.useRefElementSize(ref);
  const perPage = width <= 500 ? 1 : width <= 720 ? 2 : variant === 'featured' ? 3 : 2;

  if (!items) return null;

  return (
    <Container className={`offerings-carousel-wrapper ${variant} ${SplideStyle.splide_slidewrap}`} ref={ref}>
      {title && (
        <SectionTitle bordered={borderedTitle} level={2}>
          {title}
        </SectionTitle>
      )}
      <Carousel
        component={item => (
          <ListingPreview
            listing={item}
            showGetStartedLink={true}
            showProductTake={showProductTake}
            variant={variant}
          />
        )}
        items={items}
        options={{
          autoWidth: false,
          focus: items.length > 2 ? 'center' : 0,
          perPage,
          ...options,
        }}
        showArrowsOnlyOnOverflow={true}
      />
      {showEmailCapture && (
        <Card className="email-capture">
          <p>
            <b>Looking for additional offers?</b> Sign up to get offers directly to your inbox!
          </p>
          <AltsForm />
        </Card>
      )}
    </Container>
  );
};

export default OfferingsCarousel;

const Container = styled.div`
  &.offerings-carousel-wrapper {
    display: grid;
    grid-column: 1 / span 3;

    .section-title {
      margin-bottom: 1rem;
    }

    .carousel-container {
      display: flex;
      flex-direction: column;
    }

    @media (max-width: 640px) {
      grid-column: 1 / span 1;
      .splide__slide {
        width: 100%;
      }
    }
  }
  .email-capture {
    margin-top: 1rem;
    color: white;
    background: #3f83f8;
    .hubspot-form {
      color: rgb(45, 45, 45);
      background: white;
    }
  }
`;
